var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`author-image-molecule is--variant-${_vm.variant}`},[_c('EsyImg',{attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }